import BaseFormPresenter from "../../base/BaseFormPresenter";

class SellerFormPresenter extends BaseFormPresenter {
  async save() {
    const collection = this.view.getCollectionName();
    if (this.object.id) {
      this.change.id = this.object.id;
    }

    try {
      await this.upsertUseCase.execute(collection, this.change);
      this.change = {};
    } catch (error) {
      throw error; // rethrow the error to be caught by the caller
    }
  }
}

export default SellerFormPresenter;
